import { useEffect, useRef } from 'react';
import './Innovation.css';

import RealTime from '../../../images/real_time_analyyst.png';
import ReliabilityImg from '../../../images/Reliability.png';
import OrbitalLogo from '../../../images/orbital_logo.png';
import Privacy from '../../../images/Privacy.png';

interface OrbitingElement {
  id: string;
  ring: 'outer' | 'middle' | 'inner';
  img?: string;
  isDot?: boolean;
  color?: string;
  angleOffset: number;
}

const orbitingElements: OrbitingElement[] = [
  { id: 'outer1', ring: 'outer', img: ReliabilityImg, angleOffset: 0 },
  { id: 'outer2', ring: 'outer', img: Privacy, angleOffset: 180 },
  { id: 'middle1', ring: 'middle', img: RealTime, angleOffset: 45 },
  { id: 'middle2', ring: 'middle', isDot: true, color: '#D8E7FD', angleOffset: 250 },
  { id: 'inner', ring: 'inner', isDot: true, color: '#1780FB', angleOffset: 0 },
];

const Innovation: React.FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const elementRefs = useRef<Record<string, HTMLDivElement | null>>({});

  useEffect(() => {
    const animate = () => {
      const t = Date.now();
      const container = containerRef.current;
      const bounds = container?.getBoundingClientRect?.();
      if (!bounds) return;

      const cx = bounds.width / 2;
      const cy = bounds.height / 2;

      orbitingElements.forEach((el) => {
        const dom = elementRefs.current[el.id];
        if (!dom) return;

        let r = 0;
        let speed = 0.0002;

        if (el.ring === 'outer') {
          r = bounds.width * 0.42;
          speed = 0.00025;
        } else if (el.ring === 'middle') {
          r = bounds.width * 0.29;
          speed = 0.00035;
        } else {
          r = bounds.width * 0.16;
          speed = 0.0005;
        }

        const angle = t * speed + (el.angleOffset * Math.PI) / 180;
        const x = cx + r * Math.cos(angle);
        const y = cy + r * Math.sin(angle);

        dom.style.left = `${x}px`;
        dom.style.top = `${y}px`;
      });

      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  return (
    <div className="innovationContainer">
      <div className="orbitalContainer" ref={containerRef}>
        <div className="ring ring-outer" />
        <div className="ring ring-middle" />
        <div className="ring ring-inner" />
        <div className="center-logo">
          <img src={OrbitalLogo} alt="Center Logo" className="core-logo" />
        </div>

        {orbitingElements.map((item) => (
          <div
            key={item.id}
            ref={(el) => (elementRefs.current[item.id] = el)}
            style={item.isDot ? { backgroundColor: item.color } : {}}
            className={item.isDot ? 'orbiting-dot' : 'orbiting-orb'}
          >
            {!item.isDot && (
              <img src={item.img} alt={item.id} className="orb-img" />
            )}
          </div>
        ))}
      </div>
      <div className="innovationText">
        <p className="label">INNOVATION</p>
        <h2>Ease Margin</h2>
        <p>Driving Innovation Across India</p>
      </div>
    </div>
  );
};

export default Innovation;
